import React from 'react';
import Card from '@material-ui/core/Card';

/**
 * This function renders the BiophysicsPage page
 * @component BiophysicsPage
 * @return {Component} BiophysicsPage component
 */
export default function BiophysicsPage() {
  return (
    <Card
      style={{
        padding: '50px',
        width: '1200px',
        margin: '30px auto 30px auto',
      }}
    >
      <div style={{borderBottom: '1px solid silver', paddingBottom: '5px'}}>
        <h1 style={{paddingBottom: '2px'}}>
          Biophysics Beyond 2022: Defending Domestic Time & Space
        </h1>
      </div>
      <br />
      <div className="biological-container">
        <p>
          While biotechnologists find many practical applications for biophysics
          data, the most valuable solutions are those with the potential for
          macro biodefense.
        </p>
        <p>
          Biophysicists aren’t just talking theory when discussing weapons with
          capability to alter the mind and disorient the body. Today, the United
          States continues to grow impacted by high-tech terrorists manipulating
          persons of interest for money, information, or duty negligence. Such
          terror cells are oftentimes nation-state sponsored, as physics warfare
          devices are not typically derived from simple means.
        </p>
        <p>
          How do we defend our nation against radical biological warfare, and
          when will those solutions become a common protocol? The answer is so
          complex, it requires the future to complete.
        </p>
        <p>
          If we consider how long it would take to account for every American at
          the core asset level (physics) worldwide, it is easy to recognize the
          time and expense involved in accomplishing that goal. In 2022,
          defending America against next-generation warfare requires
          participation in a multi-circa biodefense strategy, to counter attack
          challenges while navigating a security plan everyone can appreciate.
        </p>
        <h2>Multi-Circa Biodefense Initiatives</h2>
        <p>
          The Advanced Intelligence Services Corporation’s multi-circa
          biodefense initiatives involve sophisticated methodologies used to
          improve the way military personnel organize and execute goals,
          objectives, and tasks. These functions are bridged by Essential
          Communications Hardware (ECHs), including specialized technologies
          pivotal in ensuring the unified defense vision is met with as little
          interference as possible.
        </p>
        <p>
          Multi-circa operating offers a precision method for achieving national
          defense objectives against efforts of metabolic physics warfare,
          radical biophysics warfare, and the potential for high-tech
          bioterrorism. Multi-circa operating works well with short- and
          long-term biodefense goals to improve the durability and
          sustainability of solution application in, and beyond the circa of
          invention.
        </p>
        <h2>A.I.S. Division of Modern Astrophysics</h2>
        <p>
          <i>Astrophysics </i>is the authority of study explaining space and
          it’s dynamic contents. Throughout history, astrophysicists based their
          estimations on the conduct of celestial bodies in the effort to
          predict the physical conditions of the cosmos. In the future, modern
          astrophysics research will evolve into a user-friendly, fact-based
          information network improving the quality of deep space exploration
          and off-planet community living operations, long-term.
        </p>
        <p>
          America’s next-generation of astrophysics research objectives require
          external funding in order to provide A.I.S. information research
          scientists a solid understanding of the biological aspects and
          physiological expression of the Universe around us, as well as the
          trillions of humans who ultimately inhabit this space.
        </p>
        <p>
          Progressive theories in astrophysics have led researchers at the
          Advanced Intelligence Services Corporation to recognize the world
          around us in new, and important ways. Many military and consumer
          technologies were derived from the physics achievements of space
          travel pioneers and their generational colleagues. In the near future,
          scientists may understand how to invent independent biospheres of
          their own using ingredients found right here on Earth – an
          unsurprising finding to many experts who believe the Universe is made
          entirely of biological components, regardless of their chemical
          composition.
        </p>
      </div>
    </Card>
  );
}
